import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getCategoryTemplates = createAsyncThunk(
  "MarketingCenterDigital/getCategoryTemplates",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/marketing/templates?category=${data?.categoryId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
